<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 flex-header text-center text-sm-left mb-0">
        <h3 class="page-title">Sądy</h3>
        <d-button
          theme="success"
          @click.prevent="showCourtModal">
          <i class="material-icons">add</i> Dodaj sąd
        </d-button>
      </div>
    </div>

    <!-- Default Light Table -->
    <template v-if="loadError">
      <d-alert
        show
        theme="warning">
        Wczytywanie danych nie powiodło się.
        <a
            href="javascript:window.location.reload();"
            class="alert-link">
            Odśwież stronę
        </a>
        aby spróbować ponownie.
      </d-alert>
    </template>
    <template v-else>
      <transition name="fade">
        <d-card class="card-small">
          <div
            v-if="!loaded"
            class="overlay-loading">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
          </div>
          <d-card-body class="p-0 pb-3">
            <table class="table mb-0 responsive-table">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0 text-left">Nazwa</th>
                  <th scope="col" class="border-0 text-center" style="width: 200px;">Akcje</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(court, index) in courts"
                  :key="court.id">
                  <td class="text-left">
                    <dt>Nazwa</dt>
                    <dd>{{ court.name }}</dd>
                  </td>
                  <td class="text-center">
                    <dt>Akcja</dt>
                    <dd class="wsnw">
                      <d-button
                        @click.prevent="editCourt(court)"
                        class="mr-2 mt-1 mb-1 ml-2"
                        :disabled="actionInProgress">
                        <i class="material-icons">edit</i> Edytuj
                      </d-button>
                      <d-button
                        theme="danger"
                        class="mr-2 mt-1 mb-1 ml-2"
                        @click.prevent="removeCourt(court.id)"
                        :disabled="actionInProgress">
                        <i class="material-icons">delete</i> Usuń
                      </d-button>
                    </dd>
                  </td>
                </tr>
                <tr v-if="courts.length === 0">
                  <td colspan="2" class="text-center text-info">
                    Brak sądów do wyświetlenia&hellip;
                  </td>
                </tr>
              </tbody>
            </table>
          </d-card-body>
          <d-card-footer>
            <ss-pagination
              :meta-data="paginationMetaData"
              :initial-page="currentPage" />
          </d-card-footer>
        </d-card>
      </transition>
    </template>

    <court-modal
      :court-to-edit="selectedCourt"
      :show="isCourtModalVisible" />
  </div>
</template>

<script>
import Vue from 'vue';
import ListUtils from '@/utils/ListUtils.js';
import SsModal from '../components/common/SsModal';
import SsPagination from '@/components/common/SsPaginationNew';
import HasPagination from '@/mixins/HasPagination.vue';
import CourtModal from '@/components/courts/CourtModal';

export default {
  name: 'CourtsList',
  mixins: [HasPagination],
  components: {
    SsModal,
    SsPagination,
    CourtModal
  },
  data () {
    return {
      actionInProgress: false,
      courts: [],
      current_page: 1,
      isCourtModalVisible: false,
      loaded: false,
      loadError: false,
      selectedCourt: null
    }
  },
  mounted () {
    this.$bus.$on('court-modal-hide', this.closeCourtModal);
    this.loadItemsData();
  },
  methods: {
    loadItemsData () {
      ListUtils.loadItemsData(this, {
        method: 'post',
        endpoint: '/api/courts/items',
        listField: 'courts',
        pagination: true,
        params: {
          page: this.currentPage
        }
      });
    },
    debouncedLoadFilteredData: _.debounce(function () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      this.loadItemsData();
    }, 500),
    editCourt (court) {
      this.selectedCourt = { ...court};
      this.isCourtModalVisible = true;
    },
    showCourtModal () {
      this.selectedCourt = {};
      this.isCourtModalVisible = true;
    },
    removeCourt (courtID) {
      ListUtils.removeItem(this, {
        endpointBase: '/api/courts/delete/' + courtID,
        id: null,
        successTitle: 'Sąd został usunięty',
        successText: '',
        confirmTitle: 'Uwaga',
        confirmText: 'Czy potwierdzasz usunięcie sądu?',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie sądu nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.actionInProgress = false;
          this.debouncedLoadFilteredData();
        },
        failAction: () => {
          this.actionInProgress = false;
        },
        cancelAction: () => {
          this.actionInProgress = false;
        },
      });
    },
    closeCourtModal (shouldReload) {
      this.isCourtModalVisible = false;
      this.selectedCourt = {};
      if (shouldReload) {
        this.debouncedLoadFilteredData();
      }
    }
  },
  beforeDestroy() {
    this.$bus.$off('court-modal-hide', this.closeCourtModal);
  }
}
</script>
